
export class LOVConventionTypeExtension {
}
